import { take, put }     from 'redux-saga/effects';
import { SET_QUIZ_INFO } from '../actions';

const defaultName = `hidonOtzarHaMeara`;

function* getQuizInfo() {
  while(true) {
    try {

        yield take('GET_QUIZ_INFO_SAGA');
        yield put(SET_QUIZ_INFO(defaultName))

    }
    catch(err) {
      
      console.log('err  :  '+err);

    }
    finally {}
  }
}


export default getQuizInfo;
